// From https://msdn.microsoft.com/en-us/library/ms537509(v=vs.85).aspx
function getInternetExplorerVersion()
// Returns the version of Internet Explorer or a -1
{
	var rv = -1; // Return value assumes failure.
	if (navigator.appName === 'Microsoft Internet Explorer')
	{
		var ua = navigator.userAgent;
		var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
		if (re.exec(ua) !== null) {
			rv = parseFloat(RegExp.$1);
		}
	}
	return rv;
}

// From http://stackoverflow.com/questions/2631001/javascript-test-for-existence-of-nested-object-key
function doesNestedPropertyExist(obj /*, level1, level2, ... levelN*/) {
	var args = Array.prototype.slice.call(arguments, 1);

	for (var i = 0; i < args.length; i++) {
		if (!obj || !obj.hasOwnProperty(args[i])) {
			return false;
		}
		obj = obj[args[i]];
	}
	return true;
}

$(document).ready(function() {
	/*
	 * Konami-JS ~
	 * :: Now with support for touch events and multiple instances for
	 * :: those situations that call for multiple easter eggs!
	 * Code: http://konami-js.googlecode.com/
	 * Examples: http://www.snaptortoise.com/konami-js
	 * Copyright (c) 2009 George Mandis (georgemandis.com, snaptortoise.com)
	 * Version: 1.4.2 (9/2/2013)
	 * Licensed under the MIT License (http://opensource.org/licenses/MIT)
	 * Tested in: Safari 4+, Google Chrome 4+, Firefox 3+, IE7+, Mobile Safari 2.2.1 and Dolphin Browser
	 */

	try {
		var Konami = function(callback) {
			var konami = {
				addEvent: function(obj, type, fn, ref_obj) {
					if (obj.addEventListener)
						obj.addEventListener(type, fn, false);
					else if (obj.attachEvent) {
						// IE
						obj["e" + type + fn] = fn;
						obj[type + fn] = function() {
							obj["e" + type + fn](window.event, ref_obj);
						}
						obj.attachEvent("on" + type, obj[type + fn]);
					}
				},
				input: "",
				pattern: "38384040373937396665",
				load: function(link) {
					this.addEvent(document, "keydown", function(e, ref_obj) {
						if (ref_obj) konami = ref_obj; // IE
						konami.input += e ? e.keyCode : event.keyCode;
						if (konami.input.length > konami.pattern.length)
							konami.input = konami.input.substr((konami.input.length - konami.pattern.length));
						if (konami.input == konami.pattern) {
							konami.code(link);
							konami.input = "";
							e.preventDefault();
							return false;
						}
					}, this);
					this.iphone.load(link);
				},
				code: function(link) {
					window.location = link
				},
				iphone: {
					start_x: 0,
					start_y: 0,
					stop_x: 0,
					stop_y: 0,
					tap: false,
					capture: false,
					orig_keys: "",
					keys: ["UP", "UP", "DOWN", "DOWN", "LEFT", "RIGHT", "LEFT", "RIGHT", "TAP", "TAP"],
					code: function(link) {
						konami.code(link);
					},
					load: function(link) {
						this.orig_keys = this.keys;
						konami.addEvent(document, "touchmove", function(e) {
							if (e.touches.length == 1 && konami.iphone.capture == true) {
								var touch = e.touches[0];
								konami.iphone.stop_x = touch.pageX;
								konami.iphone.stop_y = touch.pageY;
								konami.iphone.tap = false;
								konami.iphone.capture = false;
								konami.iphone.check_direction();
							}
						});
						konami.addEvent(document, "touchend", function(evt) {
							if (konami.iphone.tap == true) konami.iphone.check_direction(link);
						}, false);
						konami.addEvent(document, "touchstart", function(evt) {
							konami.iphone.start_x = evt.changedTouches[0].pageX;
							konami.iphone.start_y = evt.changedTouches[0].pageY;
							konami.iphone.tap = true;
							konami.iphone.capture = true;
						});
					},
					check_direction: function(link) {
						x_magnitude = Math.abs(this.start_x - this.stop_x);
						y_magnitude = Math.abs(this.start_y - this.stop_y);
						x = ((this.start_x - this.stop_x) < 0) ? "RIGHT" : "LEFT";
						y = ((this.start_y - this.stop_y) < 0) ? "DOWN" : "UP";
						result = (x_magnitude > y_magnitude) ? x : y;
						result = (this.tap == true) ? "TAP" : result;

						if (result == this.keys[0]) this.keys = this.keys.slice(1, this.keys.length);
						if (this.keys.length == 0) {
							this.keys = this.orig_keys;
							this.code(link);
						}
					}
				}
			}

			typeof callback === "string" && konami.load(callback);
			if (typeof callback === "function") {
				konami.code = callback;
				konami.load();
			}

			return konami;
		};

		$('.a-cipo-info').on('dblclick', function() {
			new Konami(function() {
				$('.a-cipo-info').addClass('easterEgg');
			});
		});
	}
	catch(err) {
		// ensure no error gets thrown
	}
});

(function($) {
	'use strict';
	/**
	 * DownloadLink module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class DownloadLink
	 * @extends T.Module
	 */
	T.Module.DownloadLink = T.createModule({
		start: function(resolve) {
			var $ctx = $(this._ctx);

			resolve();
		}
	});
}(jQuery));

(function($) {
	'use strict';
	/**
	 * List module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class List
	 * @extends T.Module
	 */
	T.Module.List = T.createModule({
		start: function(resolve) {
			var $ctx = $(this._ctx);

			resolve();
		}
	});
}(jQuery));

(function($) {
	'use strict';

	var selector = {
			panel: '.js-m-cipo-filter__panel',
			reset: '.js-m-cipo-filter__reset',
			resetAll: '.js-m-cipo-filter__reset-all',
			categories: '.js-m-cipo-filter__categories',
			partners: '.js-m-cipo-filter__partners',
			checkbox: ':checkbox'
		},
		state = {
			resetInactive: 'state-reset-inactive'
		};

	/**
	 * CipoFilter module implementation.
	 *
	 * @author Ernst Ammann <ernscht@namics.com>
	 * @namespace T.Module
	 * @class CipoFilter
	 * @extends T.Module
	 */
	T.Module.CipoFilter = T.createModule({
		start: function(resolve) {
			var ctx = this,
				$ctx = $(ctx._ctx);

			ctx.isFiltered = false;
			ctx.filtersOpen = 0;

			ctx._events.on('cipo.filter.init', function (data) {

				// sort filters alphabetically
				data.categories.sort(function (a, b) {
					return a.toLowerCase().localeCompare(b.toLowerCase());
				});
				data.partners.sort(function (a, b) {
					return a.toLowerCase().localeCompare(b.toLowerCase());
				});

				ctx._render(data);
			});

			$ctx.on('show.bs.collapse hide.bs.collapse', ctx._checkResetAll.bind(this));

			$ctx.on('change', selector.checkbox, function () {
				var $panel = $(this).closest(selector.panel);
				ctx._changeFilter($panel);
			});

			$ctx.on('click', selector.reset, function (e) {
				e.preventDefault();
				e.stopPropagation();

				var $reset = $(this),
					$panel = $reset.closest(selector.panel),
					$checked = $panel.find(selector.checkbox + ':checked');

				if ($checked.length) {
					$checked.prop('checked', false);
					ctx._changeFilter($panel);
				}
			});

			$ctx.on('click', selector.resetAll, function (e) {
				e.preventDefault();
				e.stopPropagation();

				var $panels = $ctx.find(selector.panel),
					$checked = $panels.find(selector.checkbox + ':checked');

				if ($checked.length) {
					$checked.prop('checked', false);
					ctx._changeFilter($panels);
					ctx._checkResetAll(e);
				}
			});

			resolve();
		},

		_changeFilter: function($panels) {
			var ctx = this,
				filters = ctx._getFilters();

			ctx._updateNumber($panels);
			ctx._events.emit('cipo.filter.change', filters);
		},

		_getFilters: function() {
			var ctx = this,
				$ctx = $(ctx._ctx),
				filters = {
					categories: [],
					partners: []
				};

			$ctx.find(selector.categories + ' ' + selector.checkbox + ':checked').each(function(){
				filters.categories.push($(this).val());
			});
			$ctx.find(selector.partners + ' ' + selector.checkbox + ':checked').each(function(){
				filters.partners.push($(this).val());
			});

			return filters;
		},

		_updateNumber: function($panels) {
			if (!$panels.length) {return;}

			var ctx = this,
				$ctx = $(ctx._ctx);

			$panels.each(function(){
				var $panel = $(this),
					$number = $ctx.find('.' + $panel.data('number-class')),
					$reset = $panel.find(selector.reset),
					checked = $panel.find(selector.checkbox + ':checked').length;

				if (checked) {
					$reset.removeClass(state.resetInactive);
					$number.text('(' + checked + ')');
				}
				else {
					$reset.addClass(state.resetInactive);
					$number.text('');
				}
			});

			ctx.isFiltered = !!$ctx.find(selector.checkbox + ':checked').length;
		},

		_checkResetAll: function(e) {
			var ctx = this,
				$ctx = $(ctx._ctx),
				$reset = $ctx.find(selector.resetAll);

			if (e && e.type === 'show') {
				ctx.filtersOpen++;
				$reset.fadeOut(200);
			}
			else if (e && e.type === 'hide') {
				ctx.filtersOpen--;
				if (!ctx.filtersOpen && ctx.isFiltered) {
					$reset.fadeIn(200);
				}
				else {
					$reset.fadeOut(200);
				}
			}
			else if (!ctx.isFiltered) { // eg. for reset all
				$reset.fadeOut(150);
			}
		},

		_render: function(data) {
			var ctx = this,
				$ctx = $(ctx._ctx),
				src = $($ctx.data('tpl')).html(),
				tpl = Handlebars.compile(src);

			$ctx.find(selector.categories).html(tpl(data.categories));
			$ctx.find(selector.partners).html(tpl(data.partners));
		}
	});
}(jQuery));

(function($) {

	var selector = {
			loading: '.js-m-teaser-ad__loading-sign',
			content: '.js-m-teaser__content'
		},
		state = {
			hiddenLoading: 'm-teaser-ad__loading-sign--hidden'
		};

	'use strict';
	/**
	 * TeaserAd module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class TeaserAd
	 * @extends T.Module
	 */
	T.Module.TeaserAd = T.createModule({
		start: function(resolve) {
			var ctx = this,
				$ctx = $(this._ctx);

			ctx.ajax = {
				_reqParameter: $ctx.data('req-parameter') || {},
				_api: $ctx.data('api-url') || '',
				_datatype: 'json',
				_timeout: $ctx.data('api-timeout') || 7000
			};

			ctx.$loadingWrapper = $(selector.loading, $ctx);
			ctx.$contentWrapper = $(selector.content, $ctx);

			ctx.hbsSource = $($ctx.data('tpl')).html();
			ctx.hbsTemplate = Handlebars.compile(ctx.hbsSource);

			$.ajax({
				url: ctx.ajax._api,
				type: 'GET',
				data: ctx.ajax._reqParameter,
				dataType: ctx.ajax._datatype,
				timeout: ctx.ajax._timeout,
				contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
			})
				.done(function(data) {
					if (data && doesNestedPropertyExist(data, 'teaserAd', 'teaserAdContent')) {
						// success
						ctx._render(data.teaserAd.teaserAdContent);
					}
					else {
						// error -- do nothing --> show allready rendered fallback teaser
					}
					ctx.$loadingWrapper.addClass(state.hiddenLoading);
				})
				.fail(function(jqxhr, textStatus, errorThrown) {
					// error -- do nothing --> show allready rendered fallback teaser
					ctx.$loadingWrapper.addClass(state.hiddenLoading);
				});

			resolve();
		},
		_render: function(data) {
			var ctx = this,
				$ctx = $(ctx._ctx);

			ctx.$contentWrapper.html(ctx.hbsTemplate(data));
		}
	});
}(jQuery));

(function ($) {
	'use strict';
	/**
	 * SwapSelection module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class SwapSelection
	 * @extends T.Module
	 */
	T.Module.SwapSelection = T.createModule({
		start: function (resolve) {
			var ctx = this,
				$ctx = $(this._ctx);
				// scrollWasAbove = false;

			console.log('SwapSelection','############################');

			ctx.$matchWrapper = $('.js-swap-selection__match', $ctx);
			ctx.$matchWrapperInOverlay = $('.js-swap-selection__match-overlay', $ctx);
			// ctx.$matchOverlay = $('.js-swap-selection__info-overlay', $ctx);
			// ctx.$matchOverlayStart = $('.js-swap-selection__overlay-start', $ctx);
			// ctx.$matchOverlayEnd = $('.js-swap-selection__overlay-end', $ctx);
			ctx.$selectedAmount = $('.js-swap-selection__values-selected', $ctx);
			ctx.$bonOverlays = $('.js-swap-selection__ucb-overlay', $ctx);
			ctx.$agbWrapper = $('.js-swap-selection__agb', $ctx);
			ctx.$agbCheckbox = $('.js-swap-selection__agb-checkbox', $ctx);
			ctx.$agbErrorText = $('.js-swap-selection__agb-error', $ctx);
			ctx.$toggleButtonWrapper = $('.js-swap-selection__toggle', $ctx);
			ctx.$toggleButton = $('.js-swap-selection__toggle-button', $ctx);
			ctx.$exchangeButton = $('.js-swap-selection__swap-trigger', $ctx);
			ctx.$bons = $(".js-swap-selection__ucb", $ctx);
			ctx.amount = 0;
			ctx.goalAmount = $('.js-swap-selection__status', $ctx).data('value');
			ctx.overlayEnabled = false;

			ctx.updateAmount();
			ctx.checkMoreButton();
			if (ctx.amount !== ctx.goalAmount) {
				ctx.overlayEnabled = true;
			}

			// $(window).scroll(function () {
			// 	if (ctx.overlayEnabled) {
			// 		var scroll = $(window).scrollTop();
			// 		// if (scroll < ctx.$matchOverlayStart.offset().top - 20) {
			// 		// 	ctx.$matchOverlay.hide();
			// 		// }
			// 		// else if (scroll < ctx.$matchOverlayEnd.offset().top) {
			// 		// 	if (scrollWasAbove) {
			// 				// ctx.$matchOverlay.slideDown();
			// 				scrollWasAbove = false;
			// 			}
			// 			else {
			// 				// ctx.$matchOverlay.show();
			// 			}
			// 		}
			// 		// else {
			// 		// 	scrollWasAbove = true;
			// 			// ctx.$matchOverlay.slideUp();
			// 		}
			// 	}
			// });

			$ctx.on('click', '.js-swap-selection__ucb input', function () {
				var $input = $(this);
				$input.attr('aria-checked', $input.attr('aria-checked') === 'false');
				ctx.updateAmount();
				ctx.checkAmountMatch();
				ctx.checkMoreButton();
			});

			$ctx.on('click', '.js-swap-selection__toggle-button', function () {
				var $this = $(this);

				if ($this.hasClass('o-swap-selection__toggle-button--selected')) {
					$this.removeClass('o-swap-selection__toggle-button--selected');
					ctx.showAll();
					$this.text($this.data('less'));
					ctx.$toggleButton.attr('aria-pressed', 'true');
				}
				else {
					$this.addClass('o-swap-selection__toggle-button--selected');
					ctx.showSelectedOnly();
					// $('html, body').animate({scrollTop: $ctx.offset().top}, 400);
					$this.text($this.data('more'));
					ctx.$toggleButton.attr('aria-pressed', 'false');
				}

				ctx.checkMoreButton();
			});

			$ctx.on('click', '.js-swap-selection__agb-content input', function () {
				var $input = $(this);
				ctx.$agbWrapper.removeClass('error');
				ctx.$agbErrorText.slideUp();
				$input.attr('aria-checked', $input.attr('aria-checked') === 'false');
			});

			// OPTIMISATION use submit if meaningful
			$ctx.on('click', '.js-swap-selection__swap-trigger', function () {
				var scrollPos = 0;
				if (ctx.amount === ctx.goalAmount) {
					if (ctx.$agbCheckbox.prop('checked')) {
						var parameters = {};
						parameters.mconnectId = $ctx.data('mconnect-id');
						parameters.offerId = $ctx.data('offer-id');
						parameters.ucbCodes = ctx._getSelectedUcbCodes();
						ctx._events.emit('cipo.swap', parameters);
					}
					else {
						ctx.$agbWrapper.addClass('error');
						// scrollPos = ctx.$agbWrapper.offset().top - 20;
						// $('html, body').animate({scrollTop: scrollPos}, 800, function () {
							// handle race condition problem
							if (ctx.$agbWrapper.hasClass('error')) {
								ctx.$agbErrorText.slideDown();
							}
						// });
						ctx._track({
							event: 'cumulus-extraOfferError',
							error:  'AGB_fehlt'
						});
					}
				}
				else {
					// scrollPos = ctx.$matchOverlayStart.offset().top - 21;
					// $('html, body').animate({scrollTop: scrollPos}, 800);
					ctx._track({
						event: 'cumulus-extraOfferError',
						error:  'Auswahl_nicht_passend'
					});
				}
			});

			// Handle edge case: reloading the page with sufficient bons available
			if (ctx.$agbWrapper.length !== 0) {
				ctx.checkAmountMatch();

				// check whether selection is best match
				var isBestMatchSelection = true;
				ctx.$bons.each(function(index, bon) {
					var $bon = $(bon),
						isChecked = $bon.find('.checkbox').prop('checked'),
						isPreselected = $bon.hasClass('js-swap-selction__is-preselect');

					if ((isChecked && !isPreselected) || (!isChecked && isPreselected)) {
						isBestMatchSelection = false;
					}
				});

				if (!isBestMatchSelection) {
					ctx.$toggleButton.removeClass('o-swap-selection__toggle-button--selected');
					ctx.showAll();
					ctx.$toggleButton.text(ctx.$toggleButton.data('less'));
					ctx.$toggleButton.attr('aria-pressed', 'true');
					ctx.checkMoreButton();
				}
			}

			ctx._trackInitial();
			ctx._trackUcbs('Cumulus Extra Bon Detail Best Match');

			resolve();
		},
		// Update the amount of selected bons in the status info.
		updateAmount: function () {
			var ctx = this,
				$ctx = $(this._ctx),
				amount = 0;

			ctx.$bons.each(function (index, bon) {
				var $bon = $(bon);
				if ($bon.find('.checkbox').prop('checked')) {
					amount += $bon.data('value');
				}
			});

			ctx.amount = amount;
			ctx.$selectedAmount.text(amount);
		},
		// Check whether the goal amount and the selected bons have the same value and set the status info respectively
		// Returns whether amount matches as boolean
		checkAmountMatch: function () {
			var ctx = this,
				$ctx = $(this._ctx);

			if (ctx.amount === ctx.goalAmount) {
				ctx.$matchWrapper.fadeOut();
				window.setTimeout(function () {
					ctx.$matchWrapper.removeClass('o-swap-selection__match--error').text(ctx.$matchWrapper.data('success')).fadeIn();
				}, 400);

				// ctx.$matchOverlay.slideUp();
				ctx.overlayEnabled = false;
				return true;
			}
			else if (!ctx.$matchWrapper.hasClass('o-swap-selection__match--error')) {
				ctx.$matchWrapper.fadeOut(400);
				window.setTimeout(function () {
					ctx.$matchWrapper.addClass('o-swap-selection__match--error').text(ctx.$matchWrapper.data('selection-mismatch')).fadeIn();
				}, 400);

				ctx.$matchWrapperInOverlay.text(ctx.$matchWrapper.data('selection-mismatch'));
				var scroll = $(window).scrollTop();
				if (scroll > ctx.$matchWrapper.offset().top - 20) {
					// ctx.$matchOverlay.slideDown();
				}
				ctx.overlayEnabled = true;
			}
			return false;
		},
		// Check whether all bons are selected and the toggle more/less button gets obsolete
		checkMoreButton: function () {
			var ctx = this,
				$ctx = $(this._ctx);

			if (ctx.$bons.find('.checkbox:checked').length === ctx.$bons.length) {
				ctx.$toggleButtonWrapper.slideUp();
				// If initially all bons are selected and one gets deselected
				ctx.$toggleButton.removeClass('o-swap-selection__toggle-button--selected');
				ctx.$toggleButton.text(ctx.$toggleButton.data('less'));
				ctx.$toggleButton.attr('aria-pressed', 'true');
			}
			else if (ctx.$bons.find('.checkbox:checked').length === 0 && !ctx.$toggleButton.hasClass('o-swap-selection__toggle-button--selected')) {
				// if none is selected hide the less button
				ctx.$toggleButtonWrapper.slideUp();
			}
			else {
				ctx.$toggleButtonWrapper.slideDown();
			}
		},
		// Show all bons
		showAll: function () {
			var ctx = this,
				$ctx = $(this._ctx);

			ctx.$bons.slideDown();
			ctx._trackUcbs('Cumulus Extra Bon Detail Alle');
		},
		// Hide not selected bons
		showSelectedOnly: function () {
			var ctx = this,
				$ctx = $(this._ctx);

			ctx.$bons.each(function (index, bon) {
				var $bon = $(bon);
				if (!$bon.find('.checkbox').prop('checked')) {
					$bon.slideUp();
				}
			});

			ctx._trackUcbs('Cumulus Extra Bon Detail Selektiert', '.checkbox:checked');

		},
		// Get the id of all selected bons and form a comma seperated list
		_getSelectedUcbCodes: function () {
			var ctx = this,
				$ctx = $(this._ctx),
				result = [];

			ctx.$bons.find('.checkbox:checked').each(function(){
				result.push($(this).closest('.js-swap-selection__ucb').data('id'));
			});

			return result.join(',');
		},
		// Trigger initial page load tracking
		_trackInitial: function() {
			var ctx = this,
				$ctx = $(this._ctx),
				ecommerce = {
					detail: {
						actionField: {
							list: 'gutschein-detail'
						},
						products: [{
							name: $ctx.find('.js-swap-selection__status').text().trim() || '',
							id: '',
							price: ctx.goalAmount || '',
							category: 'ausgewählter_wert_' + ctx.amount,
							variant: $ctx.hasClass('js-swap-selection--has-sufficient') ? 'passende_bons' : 'keine_passenden_bons'
						}]
					}
				};

			ctx._events.emit('cipo.swapselection.init', ecommerce);
		},
		// Tracking ucb impressions
		_trackUcbs: function(list, selector) {
			var ctx = this,
				$ctx = $(this._ctx),
				impressions = [],
				selector = selector || ':visible';

			ctx.$bons.find(selector).closest('.js-swap-selection__ucb').each(function (index, item) {
				var $bon = $(item);

				impressions.push({
					name: $bon.data('name') || '',
					id: '',
					position: index + 1,
					price: $bon.data('value') || '',
					list: list,
					brand: 'cumulus bon',
					category: $bon.data('name') || '',
					variant: $bon.data('expires') || ''
				})
			});

			ctx._track({
				event: 'ucbImpression',
				ecommerce: {
					impressions: impressions
				}
			});
		},
		// client tracking
		_track: function (data) {
			if (typeof window.dataLayer !== 'undefined') {
				window.dataLayer.push(data);
			}
			else {
				if (typeof window.console !== 'undefined') {
					window.console.log(data);
				}
			}
		}
	});
}(jQuery));

(function ($) {
	'use strict';
	/**
	 * OfferSwap module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class OfferSwap
	 * @extends T.Module
	 */
	T.Module.OfferSwap = T.createModule({
		start: function (resolve) {
			var ctx = this,
				$ctx = $(this._ctx);

			ctx.ajax = {
				_reqParameter: $ctx.data('req-parameter') || {},
				_api: $ctx.data('api-url') || '',
				_datatype: 'json',
				_timeout: $ctx.data('api-timeout') || 7000
			};
			ctx.data = {};

			ctx.hbsResultSource = $($ctx.data('tpl-result')).html();
			ctx.hbsResultTemplate = Handlebars.compile(ctx.hbsResultSource);

			ctx.hbsErrorSource = $($ctx.data('tpl-error')).html();
			ctx.hbsErrorTemplate = Handlebars.compile(ctx.hbsErrorSource);

			ctx.$container = $ctx.find('.js-offer-swap__content');
			ctx.$apiError = $ctx.find('.js-offer-swap__api-error');

			ctx.$loadingWrapper = $('.js-offer-swap__loading-sign', $ctx);

			ctx._events.on('cipo.swap', function (parameters) {
				ctx.$loadingWrapper.removeClass('template-offer-swap__loading-sign--hidden');

				$.extend(ctx.ajax._reqParameter, parameters);

				$.ajax({
					url: ctx.ajax._api,
					type: 'GET',
					data: ctx.ajax._reqParameter,
					dataType: ctx.ajax._datatype,
					timeout: ctx.ajax._timeout,
					contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
				})
					.done(function (data) {
						if (data) {
							if (doesNestedPropertyExist(data, 'offerSwap', 'swapResult')) {
								// scroll to top of the new element and load it
								var isFirstTime = true;
								$('html, body').animate({scrollTop: ctx.$container.offset().top}, 500, function () {
									// callback gets executed twice (body and html)
									if (isFirstTime) {
										isFirstTime = false;
										ctx._render(ctx.hbsResultTemplate, data.offerSwap.swapResult);
										ctx.$loadingWrapper.addClass('template-offer-swap__loading-sign--hidden');
										ctx._trackSuccess();
										ctx._trackUcbs();
									}
								});
							}
							else if (doesNestedPropertyExist(data, 'offerSwap', 'swapError')) {
								// scroll to top of the new element and load it
								var isFirstTime = true;
								$('html, body').animate({scrollTop: ctx.$container.offset().top}, 500, function () {
									// callback gets executed twice (body and html)
									if (isFirstTime) {
										isFirstTime = false;
										ctx._render(ctx.hbsErrorTemplate, data.offerSwap.swapError);
										ctx.$loadingWrapper.addClass('template-offer-swap__loading-sign--hidden');
									}
								});
								ctx._track({
									event: 'cumulus-extraOfferError',
									error:  data.offerSwap.swapError.errorText || ''
								});
							}
							else {
								ctx._errorHandler();
							}
						}
						else {
							ctx._errorHandler();
						}
					})
					.fail(function (jqxhr, textStatus, errorThrown) {
						ctx._errorHandler();
					});
			});

			$ctx.on('click', '.js-t-offer-swap__download', function() {
				var $button = $(this);

				ctx._track({
					event: 'cumulus-extraVoucherDownload',
					expirationDate: $button.data('expires') || '',
					list: 'Tausch Uebersichtsseite Success'
				});
			});

			// Page load tracking
			if ($ctx.find('[data-t-name="SwapSelection"]').length > 0) {
				// Logged in
				ctx._events.on('cipo.swapselection.init', function (trackingData) {
					ctx._track({
						event: 'cumulus-extraOffer-detailview',
						loggedIn: true,
						ecommerce: trackingData
					});
				});
			}
			else {
				// Not logged in
				ctx._track({
					event: 'cumulus-extraOffer-detailview',
					loggedIn: false,
					ecommerce: {
						detail: {
							actionField: {
								list: 'gutschein-detail'
							},
							products: []
						}
					}
				});
			}

			resolve();
		},
		_render: function (template, data) {
			var ctx = this,
				$ctx = $(ctx._ctx);

			ctx.$container.html(template(data));
			ctx._sandbox.addModules(ctx.$container.get(0));
		},
		_errorHandler: function () {
			var ctx = this,
				$ctx = $(ctx._ctx);

			// scroll to top of the new element and load it
			$('html, body').animate({scrollTop: ctx.$container.offset().top}, 500, function () {
				ctx.$container.hide();
				ctx.$apiError.show();
				ctx.$loadingWrapper.addClass('template-offer-swap__loading-sign--hidden');
			});

			ctx._track({
				event: 'cumulus-extraOfferError',
				error: ctx.$apiError.find('.js-t-offer-swap__error-text').text().trim() || ''
			});
		},
		// Tracking successfull offer swap
		_trackSuccess: function() {
			var ctx = this,
				$ctx = $(this._ctx),
				impressions = [];

			ctx.$container.find('.js-swap-result__voucher').each(function(index, item) {
				var $voucher = $(item);

				impressions.push({
					name: 'Gutschein Cumulus Extra',
					id: '',
					price: '',
					category: '',
					variant: '',
					position: index + 1,
					list: 'Tausch Uebersichtsseite Success',
					expirationDate: 'gueltig_bis_' + $voucher.data('expire') || ''
				})
			});

			ctx._track({
				event: 'cumulus-extraOfferSuccess',
				ecommerce: {
					impressions: impressions
				}
			});
		},
		_trackUcbs: function () {
			var ctx = this,
				$ctx = $(this._ctx),
				impressions = [];

			ctx.$container.find('.js-t-offer-swap__destroy-bon').each(function (index, item) {
				var $bon = $(item);

				impressions.push({
					name: $bon.data('name') || '',
					id: '',
					position: index + 1,
					price: 0,
					list: 'Eingeloeste Bons Cumulus Extra',
					brand: 'cumulus bon',
					category: $bon.data('name') || '',
					variant: $bon.data('redeemed') || ''
				})
			});

			ctx._track({
				event: 'ucbImpression',
				ecommerce: {
					impressions: impressions
				}
			});
		},
		// client tracking
		_track: function (data) {
			if (typeof window.dataLayer !== 'undefined') {
				window.dataLayer.push(data);
			}
			else {
				if (typeof window.console !== 'undefined') {
					window.console.log(data);
				}
			}
		}
	});
}(jQuery));

(function ($) {
	'use strict';

	var selector = {
			active: ':not(.m-teaser-partner--inactive)',
			inactive: '.m-teaser-partner--inactive',
			partnerList: '.js-partner-overview__partner-list',
			teaser: '.js-partner-overview__teaser',
			teaserLink: '.js-partner-overview__teaser-link',
			sort: '.js-partner-overview__sort',
			prev: '.js-partner-overview__paging-prev',
			next: '.js-partner-overview__paging-next',
			paging: '.js-partner-overview__paging',
			pagingItem: '.js-partner-overview__paging-item',
			dropdown: '.js-partner-overview__dropdown',
			dropdownButton: '.js-partner-overview__dropdown-button',
			dropdownButtonText: '.js-partner-overview__dropdown-button__text',
			dropdownMenu: '.js-partner-overview__dropdown-menu',
			filterItem: '.js-partner-overview__filter-item',
			emptyList: '.js-partner-overview__empty-list',
			paginationStart: '.js-partner-overview__pagination-start'
		},
		state = {
			active: 'is-active',
			inactive: 'm-teaser-partner--inactive',
			invisible: 'o-control-bar--invisible',
			paginationTop: 'border-top'
		};

	/**
	 * PartnerOverview module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class PartnerOverview
	 * @extends T.Module
	 */
	T.Module.PartnerOverview = T.createModule({

		start: function (resolve) {
			var ctx = this,
				$ctx = $(this._ctx);

			// general
			ctx._events.on('t.sync', ctx._sync.bind(ctx));
			ctx.itemsPerPage = $ctx.find(selector.partnerList).data('page-size') || 9;
			ctx.$teasers = $(selector.teaser, $ctx);
			ctx.maxPages = Math.ceil(ctx.$teasers.length / ctx.itemsPerPage);

			// sorting
			ctx.SORT_A_TO_Z = 'sort_a-z';
			ctx.SORT_Z_TO_A = 'sort_z-a';
			ctx.SORT_NEWEST = 'sort_newest';
			ctx.defaultSort = $ctx.find(selector.sort).data('default-sort') || ctx.SORT_A_TO_Z;
			ctx.currentSort = ctx.defaultSort;

			// paging
			ctx.$paging = $(selector.paging, $ctx);
			ctx.$pagingPrev = ctx.$paging.find(selector.prev);
			ctx.$pagingNext = ctx.$paging.find(selector.next);
			ctx.hbsSource = $(ctx.$paging.data('tpl')).html();
			ctx.hbsTemplate = Handlebars.compile(ctx.hbsSource);

			// filter information, only for tracking reasons
			ctx.categoryFilters = '';
			ctx.partnerFilters = '';

			// event handler

			// filter
			ctx._events.on('cipo.filter.change', function (filters) {
				ctx._filterTeaser(filters);
				// track on filtering
				ctx._trackCoupons({action: 'filter'});
			});
			$ctx.on('click', function () {
				// close all filters
				$ctx.find(selector.dropdown + '.open').removeClass('open');
			});

			// sort
			$ctx.on('click', selector.dropdownButton, function (e) {
				e.preventDefault();
				e.stopPropagation();
				var $this = $(this),
					$dropdown = $this.closest(selector.dropdown);

				$ctx.find(selector.dropdown + '.open').not($dropdown).removeClass('open');  // close others
				$dropdown.toggleClass('open');
			});
			$ctx.on('click', selector.filterItem, function (e) {
				e.preventDefault();
				var $item = $(this),
					$dropdown = $item.closest(selector.dropdown),
					$menu = $dropdown.find(selector.dropdownMenu),
					$button = $dropdown.find(selector.dropdownButton),
					text = $item.text(),
					value = $item.data('value');

				ctx.currentPage = 1;
				ctx._sortTeaser(value);
				ctx._updatePaging(1);
				ctx._showTeaser(0);

				if (e.originalEvent && $item.hasClass(state.active)) { // same clicked node
					return false;
				}

				$button.find(selector.dropdownButtonText).text(text);
				$menu.find(selector.filterItem).removeClass(state.active);
				$item.addClass(state.active);

				// track on sort
				ctx._trackCoupons({action: 'sortieren'});
			});

			// paging
			$ctx.on('click', selector.pagingItem, function (e) {
				e.preventDefault();
				ctx.currentPage = $(this).data('value');
				ctx._showTeaser((ctx.currentPage - 1) * ctx.itemsPerPage);
				ctx._updatePaging();
				// track on pagination
				ctx._trackCoupons({action: 'pagination'});
				ctx._checkMoveToTop($(this));
			});
			$ctx.on('click', selector.prev, function (e) {
				e.preventDefault();
				if (!$(this).hasClass(state.invisible)) {
					ctx.currentPage--;
					ctx._showTeaser((ctx.currentPage - 1) * ctx.itemsPerPage);
					ctx._updatePaging();
					// track on pagination
					ctx._trackCoupons({action: 'pagination'});
					ctx._checkMoveToTop($(this));
				}
			});
			$ctx.on('click', selector.next, function (e) {
				e.preventDefault();
				if (!$(this).hasClass(state.invisible)) {
					ctx.currentPage++;
					ctx._showTeaser((ctx.currentPage - 1) * ctx.itemsPerPage);
					ctx._updatePaging();
					// track on pagination
					ctx._trackCoupons({action: 'pagination'});
					ctx._checkMoveToTop($(this));
				}
			});

			// teaser click for tracking
			$ctx.on('click', selector.teaserLink, function (e) {
				var $teaser = $(this).closest('.js-partner-overview__teaser'),
					index = ctx.$teasers.filter(selector.active).not(':hidden').index($teaser);
				ctx._track({
					event: 'cumulus-extraClick',
					ecommerce: {
						click: {
							actionField: {
								list: 'Partneruebersicht_Seite_' + ctx.currentPage
							},
							products: [
								{
									name: $teaser.data('title'),
									id: '',
									position: index + 1,
									page: ctx.currentPage || '',
									category: $teaser.data('categories').split(',').join('/') || '',
									variant: $teaser.data('datetime') || ''
								}
							]
						}
					}
				});
			});

			resolve();
		},

		_sync: function () {
			var ctx = this,
				$ctx = $(this._ctx);

			ctx.partners = [];
			ctx.categories = [];

			// collect categories & partners
			ctx.$teasers.each(function () {
				var $teaser = $(this),
					categories = $teaser.data('categories').split(','),
					partners = $teaser.data('title').split(','),
					i;

				if (categories.length) {
					for (i = 0; i < categories.length; i++) {
						if (categories[i] && $.inArray(categories[i], ctx.categories) === -1) {
							ctx.categories.push(categories[i]);
						}
					}
				}
				if (partners.length) {
					for (i = 0; i < partners.length; i++) {
						if (partners[i] && $.inArray(partners[i], ctx.partners) === -1) {
							ctx.partners.push(partners[i]);
						}
					}
				}
			});
			ctx._events.emit('cipo.filter.init', {categories: ctx.categories, partners: ctx.partners});

			// default sort
			var sortText = $ctx.find(selector.sort + ' [data-value=' + ctx.defaultSort + ']').addClass(state.active).text();
			$ctx.find(selector.dropdownButtonText).text(sortText);
			ctx._sortTeaser(ctx.defaultSort);

			ctx.currentPage = 1;

			ctx._filterTeaser();

			// track on page load
			ctx._trackCoupons({action: 'seite-load'});
		},

		/**
		 * Animates the page to the top of the partner overview (top border of the top pagination bar)
		 *
		 * @param $paginationItem jQuery object of the clicked pagination item (including prev and next arrow)
		 * @private
		 */
		_checkMoveToTop: function ($paginationItem) {
			var ctx = this,
				$ctx = $(this._ctx);
			if (!$paginationItem.closest(selector.paging).hasClass(state.paginationTop)) {
				$('html, body').animate({scrollTop: $ctx.find(selector.paginationStart).offset().top}, 400);
			}
		},

		_sortTeaser: function (sortType) {
			var ctx = this;

			ctx.currentSort = sortType;

			switch (sortType) {
				case ctx.SORT_NEWEST:
					ctx.$teasers.sortElements(function (a, b) {
						// second comparison criteria is 'sort_a-z'
						if ($(a).data('datetime') == $(b).data('datetime')) {
							return $(a).data('title').toLowerCase().localeCompare($(b).data('title').toLowerCase());
						}
						return $(a).data('datetime') < $(b).data('datetime') ? 1 : -1;
					}, function () {
						return this.parentNode;
					});
					break;
				case ctx.SORT_Z_TO_A:
					ctx.$teasers.sortElements(function (a, b) {
						// needs no second comparison criteria
						return $(b).data('title').toLowerCase().localeCompare($(a).data('title').toLowerCase());
					}, function () {
						return this.parentNode;
					});
					break;
				case ctx.SORT_A_TO_Z:
				default:
					ctx.$teasers.sortElements(function (a, b) {
						// needs no second comparison criteria
						return $(a).data('title').toLowerCase().localeCompare($(b).data('title').toLowerCase());
					}, function () {
						return this.parentNode;
					});
			}
		},

		// Hide and show teaser
		_showTeaser: function (start) {
			var ctx = this,
				end = start + ctx.itemsPerPage;

			ctx.$teasers.not(selector.active).attr('position', -1).parent().hide();
			ctx.$teasers.filter(selector.active).each(function (index, item) {
				var $item = $(item);
				index++;

				if (index > start && index <= end) {
					if ($item.attr('position') == index) {
						// do nothing, element is already at the correct position and visible
					}
					else {
						$item.attr('position', index).parent().hide().fadeIn();
					}
				}
				else {
					$item.attr('position', -1).parent().hide();
				}
			});
		},

		_updatePagingControls: function (newNumberPages) {
			var ctx = this;

			// only update on changes
			if (ctx.numPages && newNumberPages == ctx.numPages) {
				ctx._updatePaging();
				return;
			}

			ctx.$paging.hide();

			ctx.numPages = newNumberPages;

			// Set paging numbers
			// Paging with url parameters is not supported at the moment

			if (newNumberPages > 1) {
				var data = {
					"prev": {
						"url": "#"
					},
					"next": {
						"url": "#"
					},
					"pages": []
				};

				for (var i = 1; i <= newNumberPages; i++) {
					data.pages.push({
						'url': '#',
						'name': '' + i,
						'data-name': 'p',
						'data-value': '' + i,
						'title': i,
						'isPage': true,
						'isHiddenXs': false
					});
				}

				ctx.$paging.html(ctx.hbsTemplate(data));
				ctx.$pagingPrev = ctx.$paging.find(selector.prev);
				ctx.$pagingNext = ctx.$paging.find(selector.next);

				ctx.$paging.fadeIn().css('display', 'table');

				ctx._updatePaging();
			}
		},

		// Update paging elements
		_updatePaging: function () {
			var ctx = this;

			// Set active pager
			ctx.$paging.find('.page').removeClass(state.active);
			ctx.$paging.find('[data-value=' + ctx.currentPage + ']').addClass(state.active);

			if (ctx.currentPage === 1) {
				ctx.$pagingPrev.addClass(state.invisible);
				ctx.$pagingNext.removeClass(state.invisible);
			}
			else if (ctx.currentPage === ctx.numPages) {
				ctx.$pagingPrev.removeClass(state.invisible);
				ctx.$pagingNext.addClass(state.invisible);
			}
			else {
				ctx.$pagingPrev.removeClass(state.invisible);
				ctx.$pagingNext.removeClass(state.invisible);
			}
		},

		_filterTeaser: function (filters) {
			var ctx = this,
				isVisible, categories, partners, $teaser, i;

			if (filters) {
				ctx.$teasers.each(function () {
					$teaser = $(this);
					isVisible = false;
					categories = $teaser.data('categories').split(',');
					partners = $teaser.data('title').split(',');

					// for tracking reasons
					ctx.categoryFilters = filters.categories.join('/');
					ctx.partnerFilters = filters.partners.join('/');

					if (!filters.categories.length && !filters.partners.length) {
						isVisible = true;
					}
					if (!isVisible && filters.categories.length) {
						for (i = 0; i < categories.length; i++) {
							if ($.inArray(categories[i], filters.categories) > -1) {
								isVisible = true;
								break;
							}
						}
					}
					if (!isVisible && filters.partners.length) {
						for (i = 0; i < partners.length; i++) {
							if ($.inArray(partners[i], filters.partners) > -1) {
								isVisible = true;
								break;
							}
						}
					}
					$teaser[isVisible ? 'removeClass' : 'addClass'](state.inactive);
				});
			}

			ctx._filterPostProcesses();
		},

		// Update paging and shown teasers
		_filterPostProcesses: function () {
			var ctx = this,
				$ctx = $(this._ctx);

			ctx.numItems = ctx.$teasers.filter(selector.active).length;

			if (ctx.numItems === 0) {
				$ctx.find(selector.emptyList).fadeIn();
			}

			ctx.currentPage = 1;

			ctx._updatePagingControls(Math.ceil(ctx.numItems / ctx.itemsPerPage));
			ctx._showTeaser(0);
		},

		_trackCoupons: function (config) {
			config = config || {};

			var ctx = this,
				$ctx = $(ctx._ctx),
				impressions = [];

			// collect only visible offers
			ctx.$teasers.filter(selector.active).not(':hidden').each(function (index, item) {
				var $teaser = $(item);
				impressions.push({
					name: $teaser.data('title'),
					id: '',
					position: index + 1,
					page: ctx.currentPage || '',
					category: $teaser.data('categories').split(',').join('/') || '',
					variant: $teaser.data('datetime') || '',
					list: 'Partneruebersicht_Seite_' + ctx.currentPage
				});
			});

			ctx._track({
				event: 'cumulus-extraOverview',
				action: config.action || '',
				partnerSelected: ctx.partnerFilters || 'alle_partner',
				categorySelected: ctx.categoryFilters || 'alle_kategorien',
				sortSelected: ctx.currentSort || '',
				paginationSelected: ctx.currentPage || '',
				paginationPages: ctx.numPages || ''
			});

			ctx._track({
				event: 'cumulus-extraImpression',
				ecommerce: {
					impressions: impressions
				}
			});
		},
		// client tracking
		_track: function (data) {
			if (typeof window.dataLayer !== 'undefined') {
				window.dataLayer.push(data);
			}
			else {
				if (typeof window.console !== 'undefined') {
					window.console.log(data);
				}
			}
		}
	});
}(jQuery));

(function ($) {
	'use strict';
	/**
	 * VoucherOverview module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class VoucherOverview
	 * @extends T.Module
	 */
	T.Module.VoucherOverview = T.createModule({
		start: function (resolve) {
			var ctx = this,
				$ctx = $(this._ctx),
				impressions = [];

			// collect vouchers
			$ctx.find('.js-t-voucher-overview__voucher').each(function (index, item) {
				var $voucher = $(item);

				impressions.push({
					name: $voucher.data('name').replace('<br>', ' '),
					id: '',
					price: '',
					category: '',
					variant: 'gueltig_bis_' + $voucher.data('date'),
					list: 'Gutschein Uebersichtsseite',
					position: index + 1
				});
			});

			ctx._track({
				event: 'cumulus-extraImpression',
				ecommerce: {
					impressions: impressions
				}
			});

			// track download
			$ctx.on('click', '.js-t-voucher-overview__link', function() {
				var $link = $(this);

				ctx._track({
					event: 'cumulus-extraVoucherDownload',
					expirationDate: $link.data('expires') || '',
					list: 'Gutschein Uebersichtsseite'
				});
			});

			resolve();
		},
		// client tracking
		_track: function (data) {
			if (typeof window.dataLayer !== 'undefined') {
				window.dataLayer.push(data);
			}
			else {
				if (typeof window.console !== 'undefined') {
					window.console.log(data);
				}
			}
		}
	});
}(jQuery));